import _ from 'lodash';
import { merge, omit } from 'lodash/fp';
import moment from 'moment';
import { createAction, createReducer } from 'redux-act';

export const actions = {
  receiveOne: createAction('receive one'),
  receiveCollection: createAction('receive collection'),

  fetch: createAction('fetch collection'),
  listen: createAction('listen collection'),

  stopListening: createAction('stop listening'),

  pushOne: createAction('push one'),
  updateOne: createAction('update one'),
  setOne: createAction('set one'),
  deleteOne: createAction('delete one'),

  onePushed: createAction('one pushed'),
  oneUpdated: createAction('one updated'),
  oneSet: createAction('one set'),
  oneDeleted: createAction('one deleted')
};

const initialState = {
  events: {},
  content: {}
};

const ids = state => Object.keys(state.content);

const listenTo = {
  [actions.receiveCollection]: (state, { collectionName, collection }) => ({
    ...state,
    [collectionName]: collection
  }),
  [actions.onePushed]: (state, { collectionName, pushed }) => ({
    ...state,
    [collectionName]: merge(state[collectionName], pushed)
  }),
  [actions.oneUpdated]: (state, { collectionName, updated }) => ({
    ...state,
    [collectionName]: merge(state[collectionName], updated)
  }),
  [actions.oneSet]: (state, { collectionName, updated }) => ({
    ...state,
    [collectionName]: updated
  }),
  [actions.oneDeleted]: (state, { collectionName, id }) => ({
    ...state,
    [collectionName]: omit(id, state[collectionName])
  })
};

export const selectors = {
  ids
};

export default createReducer(listenTo, initialState);



// WEBPACK FOOTER //
// ./src/reducers/collections.js